module.exports = __webpack_public_path__ + "01ea978f/img/share-action-icon.9c12578c.svg";